// extracted by mini-css-extract-plugin
export var tagBubble = "index-module--tagBubble--1hVwZ";
export var tagBubbleAlt = "index-module--tagBubbleAlt--1Z3-U index-module--tagBubble--1hVwZ";
export var tagBubbleSelected = "index-module--tagBubbleSelected--2RrBM index-module--tagBubble--1hVwZ";